import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../data/translations';

const Footer = () => {
  const { lang } = useLang();

  const links = [
    { label: t.nav.about[lang], href: '#about' },
    { label: t.nav.services[lang], href: '#services' },
    { label: t.nav.forCompanies[lang], href: '#for-companies' },
    { label: t.nav.contact[lang], href: '#contact' },
  ];

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" data-testid="footer" className="border-t border-[#E2E8F0] bg-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Left */}
          <div>
            <div className="font-['Outfit'] font-black text-xl tracking-tight text-[#0F172A] mb-3">
              HIRIX
            </div>
            <p className="font-['Manrope'] text-xs text-[#475569] max-w-xs leading-relaxed">
              {t.contact.companyInfo}
            </p>
            <p className="font-['Manrope'] text-xs text-[#475569] whitespace-pre-line mt-1">
              {t.contact.address}
            </p>
          </div>

          {/* Right - Links */}
          <nav className="flex flex-wrap gap-6 md:gap-8">
            {links.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                data-testid={`footer-${link.href.replace('#', '')}`}
                className="font-['Manrope'] text-sm font-medium text-[#475569] hover:text-[#0F172A] transition-colors"
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-[#E2E8F0] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-['Manrope'] text-xs text-[#94A3B8]">
            &copy; {new Date().getFullYear()} Hirix Sp. z o.o. {t.footer.rights[lang]}
          </p>
          <p className="font-['Manrope'] text-xs text-[#94A3B8]">
            {t.contact.companyInfo}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
